import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axiosInstance";
import { RootState } from "../store";

export interface ApplicationDomain {
  value_stream_id: number;
  value_stream_name: string;
  applications: Application[];
}

export interface Application {
  app_id: number;
  app_name: string;
}

export interface SelectedDomain {
  app_id: Array<number>;
  value_stream_id: Array<number>;
}

export type ApplicationDomainList = ApplicationDomain[];

export interface ApplicationDomainState {
  data: ApplicationDomainList;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  selectedDomains: SelectedDomain;
  selectedUsers: any[];
}

const initialState: ApplicationDomainState = {
  data: [],
  status: "idle",
  error: null,
  selectedDomains: { app_id: [], value_stream_id: [] },
  selectedUsers: [],
};

// Thunk to fetch app domains
export const fetchApplicationDomainData = createAsyncThunk(
  "applicationDomain/fetchData",
  async (env?: string) => {
    const response = await axiosInstance.get("/appsetup/dropdown/app_domain", {
      params: env ? { env } : undefined,
    });
    return response.data.data;
  },
);

const applicationDomainSlice: any = createSlice({
  name: "applicationDomain",
  initialState,
  reducers: {
    updateSelectedDomains: (state, action: any) => {
      state.selectedDomains = action.payload;
    },
    updateSelectedUsers: (state, action: any) => {
      state.selectedUsers = action.payload;
    },
    resetStatus: (state) => {
      state.status = "idle";
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationDomainData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        fetchApplicationDomainData.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.status = "succeeded";
          state.data = action.payload;
        },
      )
      .addCase(fetchApplicationDomainData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "Failed to load data";
      });
  },
});
export const { updateSelectedDomains, updateSelectedUsers, resetStatus } =
  applicationDomainSlice.actions;
export const selectApplicationDomainData = (state: RootState) =>
  state.ApplicationDomainList;
export default applicationDomainSlice.reducer;
